module.exports = __webpack_public_path__ + "static/media/drone-alt.86ad6f84.svg";